import chartPageTemplate from './chartPage.html';
import './chartPage.scss';

export default angular
  .module('main.dashboardPanel.chartPage', [])

  .directive('chartPage', () => {
    return {
      restrict: 'E',
      template: chartPageTemplate,
      scope: {
        type: '@', // 'line' (default), 'bar', 'combined'
        header: '@',
        description: '@',
        comment: '@',
        additions: '=', // Array<{}>
        icon: '@',
        getData: '=', // function to get data for concrete time period
        stacked: '='
      },
      controller: ($scope,
                   $filter,
                   $state,
                   utils) => {
        const $t = $filter('translate');
        $scope.loading = true;

        angular.extend($scope, {
          navigateLeft: navigateLeft,
          navigateRight: navigateRight,
          canNavigateLeft: canNavigateLeft,
          canNavigateRight: canNavigateRight,
          onBackButtonClick: onBackButtonClick,
        });

        init();

        function init() {
          $scope.type = $scope.type || 'line';

          initNavigationPeriods();

          $scope.$watchGroup([
            'navigationPeriod',
            'navigationPeriod.selectedPeriod'
          ], (newValue, oldValue) => {
            if ($scope.navigationPeriod && $scope.navigationPeriod.selectedPeriod) {
              initData();
            }
          });
        }

        function initNavigationPeriods() {
          // We should limit navigation
          let minDateMoment = moment().subtract(1, 'y');

          // Current time
          let nowMoment = moment();

          // #region Periods for recent aggregation
          let recentPeriods = [];
          {
            let dateInPast = nowMoment.clone();

            let startDate = dateInPast.clone().subtract(14, 'd').startOf('d');
            let endDate = dateInPast;

            recentPeriods.push({
              id: 0,
              name: $t('dash.panel.reports.since', { date: startDate.format('ll') }),
              startDate: startDate.valueOf(),
              endDate: endDate.valueOf(),
            });
          }
          // #endregion

          // #region Periods for recent 45 days aggregation
          let recent45Periods = [];

          {
            let dateInPast = nowMoment.clone();

            let startDate = dateInPast.clone().subtract(44, 'd').startOf('d');
            let endDate = dateInPast;

            recent45Periods.push({
              id: 0,
              name: $t('locations.edit.trendsHistory.since') + ` ${startDate.format('ll')}`,
              startDate: startDate.valueOf(),
              endDate: endDate.valueOf(),
            });

            for (let i = 1; i < 10; i++) {
              let dateInPast = nowMoment.clone().subtract(45 * (i + 1) - 1, 'd');

              let startDate = dateInPast.clone().startOf('d');
              let endDate = dateInPast.clone().add(45, 'd').startOf('d');

              // Check if we pass minimum date. But our array should have at least one element.
              if (endDate.isSameOrBefore(minDateMoment) && recent45Periods.length > 0) {
                break;
              }

              recent45Periods.push({
                id: i,
                name: `${startDate.format('ll')} - ${endDate.clone().subtract(1, 'ms').format('ll')}`,
                startDate: startDate.valueOf(),
                endDate: endDate.valueOf(),
              });
            }
          }

          // #endregion

          // #region Periods for day aggregation
          let dayPeriods = [];
          for (let i = 0; i < 30; i++) {
            let dateInPast = nowMoment.clone().subtract(i, 'd');

            let startDate = dateInPast.clone().startOf('d');
            let endDate = dateInPast.clone().add(1, 'd').startOf('d');

            // Check if we pass minimum date. But our array should have at least one element.
            if (endDate.isSameOrBefore(minDateMoment) && dayPeriods.length > 0) {
              break;
            }

            dayPeriods.push({
              id: i,
              name: dateInPast.format('LL'),
              startDate: startDate.valueOf(),
              endDate: endDate.valueOf(),
            });
          }
          // #endregion

          // #region Periods for week aggregation
          let weekPeriods = [];
          for (let i = 0; i < 24; i++) {
            let dateInPast = nowMoment.clone().subtract(i, 'w');

            let startDate = dateInPast.clone().startOf('w');
            let endDate = dateInPast.clone().add(1, 'w').startOf('w');

            // Check if we pass minimum date. But our array should have at least one element.
            if (endDate.isSameOrBefore(minDateMoment) && weekPeriods.length > 0) {
              break;
            }

            weekPeriods.push({
              id: i,
              name: `${startDate.format('ll')} - ${endDate.clone().subtract(1, 'ms').format('ll')}`,
              startDate: startDate.valueOf(),
              endDate: endDate.valueOf(),
            });
          }
          // #endregion

          // #region Periods for month aggregation
          let monthPeriods = [];
          for (let i = 0; i < 24; i++) {
            let dateInPast = nowMoment.clone().subtract(i, 'M');

            let startDate = dateInPast.clone().startOf('M');
            let endDate = dateInPast.clone().add(1, 'M').startOf('M');

            // Check if we pass minimum date. But our array should have at least one element.
            if (endDate.isSameOrBefore(minDateMoment) && monthPeriods.length > 0) {
              break;
            }

            monthPeriods.push({
              id: i,
              name: dateInPast.format('MMMM, YYYY'),
              startDate: startDate.valueOf(),
              endDate: endDate.valueOf(),
            });
          }
          // #endregion

          // #region Periods for year aggregation
          let yearPeriods = [];
          for (let i = 0; i < 10; i++) {
            let dateInPast = nowMoment.clone().subtract(i, 'y');

            let startDate = dateInPast.clone().startOf('y');
            let endDate = dateInPast.clone().add(1, 'y').startOf('y');

            // Check if we pass minimum date. But our array should have at least one element.
            if (endDate.isSameOrBefore(minDateMoment) && yearPeriods.length > 0) {
              break;
            }

            yearPeriods.push({
              id: i,
              name: dateInPast.format('YYYY'),
              startDate: startDate.valueOf(),
              endDate: endDate.valueOf(),
            });
          }
          // #endregion

          $scope.navigationPeriods = [
            {
              id: 'recent',
              aggregateBy: 'none',
              chartUnit: 'day',
              name: $t('dash.panel.reports.navigationPeriods.recent'),
              periods: recentPeriods,
              selectedPeriodId: 0,
              selectedPeriod: recentPeriods[0]
            },
            {
              id: 'recent45',
              aggregateBy: 'none',
              chartUnit: 'day',
              name: $t('locations.edit.trendsHistory.navigation.recent45'),
              periods: recent45Periods,
              selectedPeriodId: 0,
              selectedPeriod: recent45Periods[0]
            },
            {
              id: 'week',
              aggregateBy: 'none',
              chartUnit: 'day',
              name: $t('dash.panel.reports.navigationPeriods.week'),
              periods: weekPeriods,
              selectedPeriodId: 0,
              selectedPeriod: weekPeriods[0]
            },
            {
              id: 'month',
              aggregateBy: 'none',
              chartUnit: 'day',
              name: $t('dash.panel.reports.navigationPeriods.month'),
              periods: monthPeriods,
              selectedPeriodId: 0,
              selectedPeriod: monthPeriods[0]
            },
            // {
            //   id: 'year',
            //   aggregateBy: 'week',
            //   chartUnit: 'month',
            //   name: $t('dash.panel.reports.navigationPeriods.year'),
            //   periods: yearPeriods,
            //   selectedPeriodId: 0,
            //   selectedPeriod: yearPeriods[0]
            // }
          ];
          $scope.navigationPeriodId = 'recent';
        }

        function initData() {
          $scope.loading = true;
          return $scope.getData($scope.navigationPeriod.selectedPeriod.startDate, $scope.navigationPeriod.selectedPeriod.endDate)
            .then((dataSeries) => {
              $scope.dataSeries = dataSeries;
              $scope.min = moment($scope.navigationPeriod.selectedPeriod.startDate).valueOf();
              $scope.max = moment($scope.navigationPeriod.selectedPeriod.endDate).valueOf();
              $scope.loading = false;
            }, (err) => {
              $scope.loading = false;
              utils.handleApiError(err);
            });
        }

        function navigateLeft() {
          if (canNavigateLeft()) {
            $scope.navigationPeriod.selectedPeriodId++;
          }
        }

        function navigateRight() {
          if (canNavigateRight()) {
            $scope.navigationPeriod.selectedPeriodId--;
          }
        }

        /**
         * Check if navigation to the past is available
         * @return {boolean}
         */
        function canNavigateLeft() {
          return !!$scope.navigationPeriod
            && !$scope.loading
            && $scope.navigationPeriod.selectedPeriodId < $scope.navigationPeriod.periods.length - 1;
        }

        /**
         * Check if navigation to the future is available
         * @return {boolean}
         */
        function canNavigateRight() {
          return !!$scope.navigationPeriod
            && !$scope.loading
            && $scope.navigationPeriod.selectedPeriodId > 0;
        }

        function onBackButtonClick() {
          $state.go('main.dashboard.panel');
        }

      }
    };
  })
  .name;
